import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../environment/environment.service';
import { HttpRequestService } from '../http/http-request.service';
import { LogService } from '../log/log.service';
import { NotificationService } from '../notification';
import { AuthService } from '../auth/auth.service';
import { UtilService } from '../util/util.service';
import { ApiService } from './api.service';
import { ServiceApiService } from './service-api.service';

@Injectable({ providedIn: 'root' })
export class WebsiteServiceApiService extends ServiceApiService {
  constructor(
    @Inject(AuthService) authService: AuthService,
    @Inject(UtilService) utilService: UtilService,
    @Inject(LogService) logService: LogService,
    @Inject(HttpRequestService) httpRequestService: HttpRequestService,
    @Inject(EnvironmentService) environmentService: EnvironmentService,
    @Inject(NotificationService) notificationService: NotificationService
  ) {
    super(authService, utilService, logService, httpRequestService, environmentService, notificationService);
    this.setBaseUrl('website');
  }
}
